module.exports = __webpack_public_path__ + "imgs/urbanMobile2x.9e9c9440.webp";